import React, { useEffect, useState } from "react";
import "./ClinicsForm.scss"

import Input from "../../../UI/Input/Input";
import PostService from '../../../../API/PostService';
import { useSelector, useDispatch } from "react-redux";
import { useFetching } from "../../../../hooks/useFetching";
import { useNavigate } from "react-router-dom";
import { setPositionsAction } from '../../../../store/specialistsReducer';
import { setSalonsAction } from '../../../../store/scheduleReducer';

const ClinicsForm = ({ id = null, salon = null }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const positions = useSelector(state => state.specialists.positions)

    const [config, setConfig] = useState({});
    const [enableFinish, setEnableFinish] = useState(false);
    const [edited, setEdited] = useState(false);
    const currensSchedule = useSelector(state => state.schedule.currensSchedule);

    useEffect(() => {
        if (salon && salon.positions) {
            const initialConfig = {
                positions: salon.positions.map(position => ({ count: 1, position: !!position && position.id }))
            };
            setConfig(initialConfig);
        }
    }, [salon]);

    const recieveSalonPosition = (value, id) => {
        let currentPosition;

        if (!config.positions || !Array.isArray(config.positions)) {
            config.positions = [];
        }

        if (config.positions.find((position) => position.position === id)) {
            currentPosition = config.positions.find((position) => position.position === id);
        }

        const newConfig = { ...config };

        if (value === "0" && currentPosition) {
            newConfig.positions = config.positions.filter((position) => position.position !== id);
        } else if (value !== "0" && !currentPosition) {
            newConfig.positions = [...config.positions, { count: 1, position: id }];
        } else if (value !== "0" && currentPosition) {
            newConfig.positions = config.positions.map((position) => {
                if (position.position === id) {
                    return { ...position, count: 1 };
                }
                return position;
            });
        }

        checkEnableFinish(newConfig, config);
        setConfig(newConfig);
    };

    console.log(salon);


    const saveChanges = () => {
        fetchUpdatePositions(config);
    }

    const [fetchUpdatePositions] = useFetching(async (data) => {
        console.log(data.positions);

        const response = await PostService.editSalonsPositions(id, data.positions)

        console.log(response);
        if (response.data.success && response.data.result !== false) {
            fetchSalons();
            fetchPositions();
            navigate('/schedule/');
        }
    })

    const [fetchPositions] = useFetching(async () => {
        const response = await PostService.getPositions()
        if (response.data.success && response.data.result !== false) {
            dispatch(setPositionsAction(response.data.result))
        }
    })

    const [fetchSalons] = useFetching(async () => {
        const response = await PostService.getWorkerSites()
        if (response.data.success && response.data.result !== false) {
            dispatch(setSalonsAction(response.data.result))
        }
    })

    const checkEnableFinish = (config, oldConfig) => {
        if ((JSON.stringify(config) !== JSON.stringify(oldConfig))) {
            setEdited(true)
        }
        let enable = true;
        if (!config.positions && config.positions.length > 0) enable = false;

        setEnableFinish(enable)
    }

    function formatWorkHours(time_start, time_end) {
        const toHHMM = (seconds) => {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        };

        return `${toHHMM(time_start)} – ${toHHMM(time_end)}`;
    }

    return (
        <div className="clinic-form">
            <>
                <div className="clinic-form__title">
                    <h3>{salon?.description}, {salon?.address}</h3>
                </div>
                <p className="clinic-form__subtitle">{salon?.settings ? "Ежедневно " : ""}<span>{salon?.settings ? formatWorkHours(salon.settings.time_start, salon.settings.time_end) : ""}</span></p>
                <div className="clinic-form__positions">
                    {positions.map((position, index) => (
                        <Input
                            label={position.name}
                            placeholder="Введите комментарий"
                            type="position"
                            inputHandler={(e) => recieveSalonPosition(e, position.id)}
                            defaultValue={salon.positions && salon.positions.find(el => !!el && el.id === position.id) ? "1" : "0"} />
                    ))}
                </div>
                <div className="clinic-form__submit">
                    <button className="g-button-secondary" onClick={saveChanges}>Сохранить</button>
                </div>
            </>
        </div>
    );
};

export default ClinicsForm;
